import { API_BASE_URL, LEGACY_DOMAIN } from "constants/index";

class ApiService {


  async fetchWithTimeout(resource, options = {}) {
    const { timeout = 8000 } = options;

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    const response = await fetch(resource, {
      ...options,
      signal: controller.signal
    });
    clearTimeout(id);

    return response;
  }
  async getPlayers() {
    console.log("in network call");
    // https://tennisballcricket.com/allplayers
    try {
      //const response = await this.fetch(`${LEGACY_DOMAIN}/allplayers`);
      //let data = await response.json();
      let data = [
        {
          "name": " Ibrahim  Rashid",
          "id": "8031",
          "teamId": "401",
          "teamName": "Fireballs"
        },
        {
          "name": " Keshav",
          "id": "20471",
          "teamId": "3",
          "teamName": "Bhola XI"
        },
        {
          "name": " varun jain",
          "id": "22914",
          "teamId": "393",
          "teamName": "TakeItEasy CC"
        },
        {
          "name": "A Arun",
          "id": "2868",
          "teamId": "31",
          "teamName": "Bay Tigers"
        },
        {
          "name": "A C",
          "id": "20069",
          "teamId": "38",
          "teamName": "MCC Lions"
        },
        {
          "name": "A Kumar",
          "id": "22509",
          "teamId": "15",
          "teamName": "Thunderbolts"
        },
        {
          "name": "a Mohammed",
          "id": "21978",
          "teamId": "364",
          "teamName": "YAM CC"
        },
        {
          "name": "A V",
          "id": "20753",
          "teamId": "339",
          "teamName": "ZZZZ-EXTRAS_XXX"
        },
        {
          "name": "Aadhar Jain",
          "id": "21692",
          "teamId": "352",
          "teamName": "ZZZZ-Lords CC"
        },
        {
          "name": "Aadithya Swaroop  Srivatsan ",
          "id": "21450",
          "teamId": "344",
          "teamName": "Hurricanes"
        },
        {
          "name": "Aakaash Mudium",
          "id": "21128",
          "teamId": "325",
          "teamName": "ZZZ_Bay9ers"
        },
        {
          "name": "Aakash Acharya",
          "id": "21829",
          "teamId": "317",
          "teamName": "ZZZZ-Willow Wizards"
        },
        {
          "name": "Aakash Arora",
          "id": "8399",
          "teamId": "20",
          "teamName": "99ers"
        },
        {
          "name": "Aakash Deep",
          "id": "23201",
          "teamId": "303",
          "teamName": "Khiladi 9211"
        },
        {
          "name": "Aakash Shah",
          "id": "23133",
          "teamId": "13",
          "teamName": "Centurions"
        },
        {
          "name": "Aakash Shah",
          "id": "25835",
          "teamId": "335",
          "teamName": "Blue Warriors"
        },
        {
          "name": "Aakash Sharma",
          "id": "23048",
          "teamId": "419",
          "teamName": "Khiladi"
        },
        {
          "name": "Aakash Sundarean",
          "id": "25687",
          "teamId": "457",
          "teamName": "Stanford CC"
        },
        {
          "name": "Aakash Verma",
          "id": "21310",
          "teamId": "200",
          "teamName": "Mad House"
        },
        {
          "name": "Aalok Desai",
          "id": "2443",
          "teamId": "155",
          "teamName": "Rhinos"
        },
        {
          "name": "Aalok Desai",
          "id": "20053",
          "teamId": "155",
          "teamName": "Rhinos"
        },
        {
          "name": "Aalok Nemani",
          "id": "20191",
          "teamId": "213",
          "teamName": "Bad Boys"
        },
        {
          "name": "Aamir Khan",
          "id": "23037",
          "teamId": "418",
          "teamName": "Shining Stars"
        },
        {
          "name": "Aarjav Sheth",
          "id": "24544",
          "teamId": "390",
          "teamName": "Dravidians"
        },
        {
          "name": "Aathreya Ganapathy",
          "id": "23508",
          "teamId": "3",
          "teamName": "Bhola XI"
        },
        {
          "name": "Aayush Ghand",
          "id": "21844",
          "teamId": "268",
          "teamName": "Eagles XI"
        },
        {
          "name": "Abbas  Gowher ",
          "id": "21911",
          "teamId": "364",
          "teamName": "YAM CC"
        },
        {
          "name": "Abbas Jaffri",
          "id": "23432",
          "teamId": "404",
          "teamName": "Ssshhh"
        },
        {
          "name": "Abbas Jafri",
          "id": "20722",
          "teamId": "364",
          "teamName": "YAM CC"
        },
        {
          "name": "Abdul ",
          "id": "5936",
          "teamId": "150",
          "teamName": "ZZZZ-I11 CC_XXX"
        },
        {
          "name": "Abdul  Razack",
          "id": "5433",
          "teamId": "461",
          "teamName": "Roadies"
        },
        {
          "name": "Abdul Aneesh Shaik",
          "id": "22894",
          "teamId": "227",
          "teamName": "Avengers"
        },
        {
          "name": "Abdul Kader Kapadia",
          "id": "25014",
          "teamId": "426",
          "teamName": "CCC XI"
        },
        {
          "name": "Abdul Majid Mohammed",
          "id": "22837",
          "teamId": "435",
          "teamName": "Royal Kings"
        },
        {
          "name": "Abdul Malik",
          "id": "20591",
          "teamId": "13",
          "teamName": "Centurions"
        },
        {
          "name": "Abdul Rahim",
          "id": "22868",
          "teamId": "395",
          "teamName": "ZZZ_Afghan"
        },
        {
          "name": "Abdul Rasheed",
          "id": "21515",
          "teamId": "353",
          "teamName": "ZZZ_Sulaimani"
        },
        {
          "name": "Abdul Samad",
          "id": "20860",
          "teamId": "334",
          "teamName": "ZZZZ-Fremont Fighters"
        },
        {
          "name": "Abdul Shaik",
          "id": "24113",
          "teamId": "3",
          "teamName": "Bhola XI"
        },
        {
          "name": "Abdulla Mohammad",
          "id": "25991",
          "teamId": "335",
          "teamName": "Blue Warriors"
        },
        {
          "name": "Abdullah abbasi",
          "id": "20246",
          "teamId": "54",
          "teamName": "SE11"
        },
        {
          "name": "Abdullah Abbasi",
          "id": "20745",
          "teamId": "54",
          "teamName": "SE11"
        },
        {
          "name": "Abdullah Sheik Ibrahim",
          "id": "21851",
          "teamId": "242",
          "teamName": "Smashers"
        },
        {
          "name": "Abdulshakoor Siddiqui",
          "id": "22794",
          "teamId": "395",
          "teamName": "ZZZ_Afghan"
        },
        {
          "name": "Abdur Raheem",
          "id": "20724",
          "teamId": "338",
          "teamName": "ZZZZ-Nextgen "
        },
        {
          "name": "Abhay Chennagiri",
          "id": "26009",
          "teamId": "430",
          "teamName": "Garfielders"
        },
        {
          "name": "abhay kumar",
          "id": "20754",
          "teamId": "339",
          "teamName": "ZZZZ-EXTRAS_XXX"
        },
        {
          "name": "Abhay Patil",
          "id": "24150",
          "teamId": "390",
          "teamName": "Dravidians"
        },
        {
          "name": "Abhay Pendawle",
          "id": "25975",
          "teamId": "419",
          "teamName": "Khiladi"
        }
      ];
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }

  }
  async getPlayerDetails(playerId) {

    // https://tennisballcricket.com/teamplayerscore/player/23133
    try {
      const response = await fetch(`${LEGACY_DOMAIN}/teamplayerscore/player/${playerId}`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  async getPlayerAwards(playerId) {
    //https://tennisballcricket.com/getPlayerAwards?playerId=6452
    try {
      const response = await fetch(`${LEGACY_DOMAIN}/getPlayerAwards?playerId=${playerId}`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  async getPlayerPerformanceInCurrentTournament(playerId) {
    // * https://tennisballcricket.com/getPerformance?PlayerId=6452
    try {
      const response = await fetch(`${LEGACY_DOMAIN}/getPerformance?PlayerId=${playerId}`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  async getPlayerPerformanceInTournament(playerId, tournamentId) {
    //https://tennisballcricket.com/getPerformance?PlayerId=6452&TopTourId=76
    try {
      const response = await fetch(`${LEGACY_DOMAIN}/getPerformance?PlayerId=${playerId}&TopTourId=${tournamentId}`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  async getTeams() {
    try {
      //const response = await fetch(`${API_BASE_URL}/teams`);
      //let data = await response.json();
      let data = [{ "TeamId": 1, "TeamName": "ZZZZ-NA", "ShortName": "NA", "Email": "", "Status": "0" }, { "TeamId": 3, "TeamName": "Bhola XI", "ShortName": "Bhola XI", "Email": "", "Status": "1" }, { "TeamId": 4, "TeamName": "ZZZZ-Warriors_XXX", "ShortName": "Warriors", "Email": "", "Status": "0" }, { "TeamId": 5, "TeamName": "ZZZZ-Kasturi Pade", "ShortName": "Kasturi Pade", "Email": "", "Status": "0" }, { "TeamId": 6, "TeamName": "Panthers", "ShortName": "Panthers", "Email": "", "Status": "1" }, { "TeamId": 8, "TeamName": "Packers CC", "ShortName": "Packers CC", "Email": "", "Status": "1" }, { "TeamId": 9, "TeamName": "Champions CC", "ShortName": "CCC", "Email": "", "Status": "1" }, { "TeamId": 12, "TeamName": "ZZZZ-Catalysters_XXX", "ShortName": "Catalysters", "Email": "", "Status": "0" }, { "TeamId": 13, "TeamName": "Centurions", "ShortName": "Centurions", "Email": "", "Status": "1" }, { "TeamId": 15, "TeamName": "Thunderbolts", "ShortName": "Thunderbolts", "Email": "", "Status": "1" }, { "TeamId": 17, "TeamName": "ZZZZ-Spanglers_XXX", "ShortName": "Spanglers", "Email": "", "Status": "0" }, { "TeamId": 18, "TeamName": "ZZZZ-Chennai 94086_XXXX", "ShortName": "Chennai 94086", "Email": "", "Status": "0" }, { "TeamId": 19, "TeamName": "ZZZZ-Baslog_XXX", "ShortName": "Baslog", "Email": "", "Status": "0" }, { "TeamId": 20, "TeamName": "99ers", "ShortName": "99ers", "Email": "99ers@email.com", "Status": "1" }, { "TeamId": 21, "TeamName": "Hurricane Stars", "ShortName": "Hurricane Stars", "Email": "", "Status": "1" }, { "TeamId": 22, "TeamName": "ZZZZ-Ranji CC_XXXX", "ShortName": "Ranji CC", "Email": "", "Status": "0" }, { "TeamId": 31, "TeamName": "Bay Tigers", "ShortName": "Bay Tigers", "Email": "", "Status": "1" }, { "TeamId": 34, "TeamName": "Yorkers", "ShortName": "Yorkers", "Email": "", "Status": "1" }, { "TeamId": 38, "TeamName": "MCC Lions", "ShortName": "MCC Lions", "Email": " ", "Status": "1" }, { "TeamId": 43, "TeamName": "BYE", "ShortName": "BYE", "Email": "", "Status": "1" }, { "TeamId": 49, "TeamName": "ZZZ_Beamers", "ShortName": "ZZZ_Beamers", "Email": "", "Status": "0" }, { "TeamId": 54, "TeamName": "SE11", "ShortName": "SE11", "Email": "", "Status": "1" }, { "TeamId": 71, "TeamName": "ZZZZ-Chargers_XXXX", "ShortName": "Chargers", "Email": "", "Status": "0" }, { "TeamId": 76, "TeamName": "ZZZ_Chumma TP", "ShortName": "ZZZ_Chumma TP", "Email": "", "Status": "0" }, { "TeamId": 109, "TeamName": "Checkthat.co", "ShortName": "Nexus CC", "Email": "", "Status": "1" }, { "TeamId": 131, "TeamName": "ZZZZ-Mustangs_XXXX", "ShortName": "Mustangs", "Email": "", "Status": "0" }, { "TeamId": 148, "TeamName": "ZZZZ-Titans XI", "ShortName": "Titans XI", "Email": "", "Status": "0" }, { "TeamId": 150, "TeamName": "ZZZZ-I11 CC_XXX", "ShortName": "I11 CC", "Email": "", "Status": "0" }, { "TeamId": 155, "TeamName": "Rhinos", "ShortName": "Rhinos", "Email": "", "Status": "1" }, { "TeamId": 168, "TeamName": "ZZZZ-The Dark Knights_XXXX", "ShortName": "The Dark Knights", "Email": "", "Status": "0" }, { "TeamId": 170, "TeamName": "ZZZZ-Enthu 11_XXXX", "ShortName": "Enthu 11", "Email": "", "Status": "0" }, { "TeamId": 172, "TeamName": "Megablasters", "ShortName": "Megablasters", "Email": "", "Status": "1" }, { "TeamId": 173, "TeamName": "Acers", "ShortName": "Acers", "Email": "", "Status": "1" }, { "TeamId": 184, "TeamName": "Dukes XI", "ShortName": "Dukes XI", "Email": "", "Status": "1" }, { "TeamId": 192, "TeamName": "Stags", "ShortName": "Stags", "Email": "", "Status": "1" }, { "TeamId": 195, "TeamName": "ZZZZ-San Francisco BHAICHARA_XXXX", "ShortName": "San Francisco BHAICHARA", "Email": "", "Status": "0" }, { "TeamId": 200, "TeamName": "Mad House", "ShortName": "Mad House", "Email": "", "Status": "1" }, { "TeamId": 209, "TeamName": "ZZZZ-Rebels_XXXX", "ShortName": "Rebels", "Email": "", "Status": "0" }, { "TeamId": 211, "TeamName": "Royal Knights", "ShortName": "Royal Knights", "Email": "", "Status": "1" }, { "TeamId": 212, "TeamName": "ZZZ_Underdogs", "ShortName": "ZZZnderdogs", "Email": "", "Status": "0" }, { "TeamId": 213, "TeamName": "Bad Boys", "ShortName": "Bad Boys", "Email": "", "Status": "1" }, { "TeamId": 222, "TeamName": "ZZZZ-Gladiators_XXXX", "ShortName": "Gladiators", "Email": "", "Status": "0" }, { "TeamId": 227, "TeamName": "Avengers", "ShortName": "Avengers", "Email": "", "Status": "1" }, { "TeamId": 229, "TeamName": "United CC", "ShortName": "United CC", "Email": "", "Status": "1" }, { "TeamId": 234, "TeamName": "ZZZZ-Force 11_XXXX", "ShortName": "Force 11", "Email": "", "Status": "0" }, { "TeamId": 240, "TeamName": "ZZZZ-Assaulters_XXXX", "ShortName": "Assaulters", "Email": "", "Status": "0" }, { "TeamId": 242, "TeamName": "Smashers", "ShortName": "Smashers", "Email": "", "Status": "1" }, { "TeamId": 244, "TeamName": "ZZZZ-Simply Cricket_XXXX", "ShortName": "Simply Cricket", "Email": "", "Status": "0" }, { "TeamId": 245, "TeamName": "ZZZZ-Absolute XI_XXXX", "ShortName": "Absolute XI", "Email": "-", "Status": "0" }, { "TeamId": 253, "TeamName": "Jaguars", "ShortName": "Jaguars", "Email": "", "Status": "1" }, { "TeamId": 255, "TeamName": "ZZZZ-California Super Kings_XXX", "ShortName": "CSK", "Email": "", "Status": "0" }, { "TeamId": 257, "TeamName": "ZZZZ-Terminators", "ShortName": "Terminators", "Email": "", "Status": "0" }, { "TeamId": 264, "TeamName": "Dream Killers", "ShortName": "Dream Killers", "Email": "", "Status": "1" }, { "TeamId": 268, "TeamName": "Eagles XI", "ShortName": "Eagles XI", "Email": "", "Status": "1" }, { "TeamId": 269, "TeamName": "ZZZZ-SC Athletics_XXXX", "ShortName": "SCA", "Email": "", "Status": "0" }, { "TeamId": 273, "TeamName": "ZZZZ-Finishers_XXXX", "ShortName": "Finishers", "Email": "", "Status": "0" }, { "TeamId": 289, "TeamName": "ZZZZ-Dynamites_XXXX", "ShortName": "Dynamites", "Email": "", "Status": "0" }, { "TeamId": 292, "TeamName": "San Jose Stunners", "ShortName": "SJ Stunners", "Email": "", "Status": "1" }, { "TeamId": 296, "TeamName": "ZZZZ-Talons_XXXX", "ShortName": "Talons", "Email": "", "Status": "0" }, { "TeamId": 300, "TeamName": "DareDevils", "ShortName": "DareDevils", "Email": "", "Status": "1" }, { "TeamId": 303, "TeamName": "Khiladi 9211", "ShortName": "Youngistan", "Email": "", "Status": "1" }, { "TeamId": 305, "TeamName": "Krazy Hitters", "ShortName": "Krazy Hitters", "Email": "", "Status": "1" }, { "TeamId": 308, "TeamName": "ZZZZ-Hillsdale Hurricanes_XXXX", "ShortName": "Hillsdale Hurricanes", "Email": "", "Status": "0" }, { "TeamId": 310, "TeamName": "ZZZZ-Rocket Rajas_XXXX", "ShortName": "Rocket Rajas", "Email": "", "Status": "0" }, { "TeamId": 311, "TeamName": "ZZZZ-Sarvavid_XXXX", "ShortName": "sarvavid", "Email": "info@sarvavid.com", "Status": "0" }, { "TeamId": 312, "TeamName": "ZZZZ-Positano Cricket Club_XXXX", "ShortName": "PCC", "Email": "pankajgautam@yahoo.com", "Status": "0" }, { "TeamId": 315, "TeamName": "ZZZZ-BraveHearts_XXXX", "ShortName": "BraveHearts", "Email": "", "Status": "0" }, { "TeamId": 317, "TeamName": "ZZZZ-Willow Wizards", "ShortName": "Willow Wizards", "Email": "", "Status": "0" }, { "TeamId": 318, "TeamName": "ZZZ_Adventure XI", "ShortName": "ZZZ_Adventure XI", "Email": "", "Status": "0" }, { "TeamId": 319, "TeamName": "ZZZZ-Bravos_XXXX", "ShortName": "Bravos", "Email": "", "Status": "0" }, { "TeamId": 320, "TeamName": "Drunken Hammers", "ShortName": "DHCC", "Email": "", "Status": "1" }, { "TeamId": 321, "TeamName": "ZZZZ-Victorious Secret_XXXX", "ShortName": "VS", "Email": "", "Status": "0" }, { "TeamId": 322, "TeamName": "ZZZZ-Cheetahs_XXXX", "ShortName": "Cheetahs", "Email": "", "Status": "0" }, { "TeamId": 323, "TeamName": "ZZZZ-Canvas Infotech_XXXX", "ShortName": "Canvas IT", "Email": "", "Status": "0" }, { "TeamId": 324, "TeamName": "ZZZZ-Sunrisers_XXXX", "ShortName": "Sunrisers", "Email": "", "Status": "0" }, { "TeamId": 325, "TeamName": "ZZZ_Bay9ers", "ShortName": "ZZZ_Bay9ers", "Email": "", "Status": "0" }, { "TeamId": 326, "TeamName": "Juggernauts", "ShortName": "Juggernauts", "Email": "niteshphatnani@gmail.com", "Status": "1" }, { "TeamId": 327, "TeamName": "ZZZZ-Grasshoppers_XXXX", "ShortName": "Grasshoppers", "Email": "ankitdahiya18@gmail.com", "Status": "0" }, { "TeamId": 328, "TeamName": "Jolly Rovers", "ShortName": "Jolly Rovers", "Email": "mamilla.raghuveer@gmail.com", "Status": "1" }, { "TeamId": 329, "TeamName": "ZZZZ-Royals", "ShortName": "Royals", "Email": "Jatin.chawla@gmail.com", "Status": "0" }, { "TeamId": 330, "TeamName": "ZZZZ-Warriors XI", "ShortName": "Warriors XI", "Email": "madhav.chaudhari@gmail.com", "Status": "0" }, { "TeamId": 331, "TeamName": "ZZZZ-Jaathre Boys_XXXX", "ShortName": "Jaathre Boys", "Email": "devapriya.rajashekar@gmail.com", "Status": "0" }, { "TeamId": 332, "TeamName": "Fearless Falcons", "ShortName": "Fearless Falcons", "Email": "pravs2607@gmail.com", "Status": "1" }, { "TeamId": 334, "TeamName": "ZZZZ-Fremont Fighters", "ShortName": "Fremont Fighters", "Email": "dattu.akella@gmail.com", "Status": "0" }, { "TeamId": 335, "TeamName": "Blue Warriors", "ShortName": "Blue Warriors", "Email": "parmar.jenit40@gmail.com", "Status": "1" }, { "TeamId": 336, "TeamName": "ZZZZ-Halal Brothers_XXXX", "ShortName": "Halal Brothers", "Email": "mrlakdawala@gmail.com", "Status": "0" }, { "TeamId": 337, "TeamName": "ZZZZ-Challengers CC_XXXX", "ShortName": "Challengers CC", "Email": "sita_sree@yahoo.com", "Status": "0" }, { "TeamId": 338, "TeamName": "ZZZZ-Nextgen ", "ShortName": "Nextgen", "Email": "", "Status": "0" }, { "TeamId": 339, "TeamName": "ZZZZ-EXTRAS_XXX", "ShortName": "EXT", "Email": "", "Status": "0" }, { "TeamId": 340, "TeamName": "ZZZZ-MCIS Jiye Ja", "ShortName": "MCIS Jiye Ja", "Email": "nssjobs@att.net", "Status": "0" }, { "TeamId": 341, "TeamName": "ZZZZ-KINGFISHERS_XXXX", "ShortName": "KINGFISHERS", "Email": "rohit.tanneru@gmail.com", "Status": "0" }, { "TeamId": 342, "TeamName": "TCA GC", "ShortName": "TCA GC", "Email": "bagames@tennisballcricket.com", "Status": "1" }, { "TeamId": 343, "TeamName": "ZZZZ-SRCCWINNERS_XXXX", "ShortName": "SRCCWINNERS", "Email": "mahendra.pudi@gmail.com", "Status": "0" }, { "TeamId": 344, "TeamName": "Hurricanes", "ShortName": "Hurricanes", "Email": "al.enighost@gmail.com`", "Status": "1" }, { "TeamId": 345, "TeamName": "ZZZZ-TCA Looking For Team", "ShortName": "", "Email": "tacgc@yahoo.com", "Status": "0" }, { "TeamId": 346, "TeamName": "Mahishmathi 2.0", "ShortName": "Mahishmathi", "Email": "sure_chinni2002@yahoo.com", "Status": "1" }, { "TeamId": 347, "TeamName": "Sun Risers", "ShortName": "Sun Risers", "Email": "grandhisarath6788@gmail.com", "Status": "1" }, { "TeamId": 348, "TeamName": "ZZZZ-Intuit XI", "ShortName": "Intuit XI", "Email": "Sudarsan_Mukundhan@intuit.com", "Status": "0" }, { "TeamId": 349, "TeamName": "PGC", "ShortName": "PGC", "Email": "shishira88@gmail.com", "Status": "1" }, { "TeamId": 350, "TeamName": "ZZZZ-Pinch Hitters", "ShortName": "Pinch Hitters", "Email": "randhawap@outlook.com", "Status": "0" }, { "TeamId": 351, "TeamName": "ZZZZ-Ladies", "ShortName": "Ladies", "Email": "sjaipuri@gmail.com", "Status": "0" }, { "TeamId": 352, "TeamName": "ZZZZ-Lords CC", "ShortName": "Lords CC", "Email": "", "Status": "0" }, { "TeamId": 353, "TeamName": "ZZZ_Sulaimani", "ShortName": "ZZZ_Sulaimani", "Email": "Sulaimani", "Status": "0" }, { "TeamId": 354, "TeamName": "CSK", "ShortName": "CSK", "Email": "tbd", "Status": "1" }, { "TeamId": 355, "TeamName": "SWAGGERs", "ShortName": "SWAGGERs", "Email": "SWAGGERs", "Status": "1" }, { "TeamId": 356, "TeamName": "Rebels", "ShortName": "Rebels", "Email": "", "Status": "1" }, { "TeamId": 357, "TeamName": "ZZZZ-Team SuperStars", "ShortName": "Cric Stumps", "Email": "", "Status": "0" }, { "TeamId": 358, "TeamName": "ZZZZ-Team RockStars", "ShortName": "Cric Ton", "Email": "", "Status": "0" }, { "TeamId": 359, "TeamName": "ZZZZ-Swat kats", "ShortName": "Swat kats", "Email": "ananthsangari@gmail.com", "Status": "0" }, { "TeamId": 360, "TeamName": "Royal Blues", "ShortName": "Royal Blues", "Email": "", "Status": "1" }, { "TeamId": 361, "TeamName": "Mighty Warriors", "ShortName": "Mighty Warriors", "Email": "", "Status": "1" }, { "TeamId": 362, "TeamName": "Gully Cricketers", "ShortName": "Gully Cricketers", "Email": "", "Status": "1" }, { "TeamId": 363, "TeamName": "ZZZZ-New Crescent CC", "ShortName": "New Crescent CC", "Email": "", "Status": "0" }, { "TeamId": 364, "TeamName": "YAM CC", "ShortName": "YAM CC", "Email": "", "Status": "1" }, { "TeamId": 366, "TeamName": "Blazers", "ShortName": "Blazers", "Email": "", "Status": "1" }, { "TeamId": 367, "TeamName": "Kricketers", "ShortName": "Kricketers", "Email": "", "Status": "1" }, { "TeamId": 368, "TeamName": "ZZZZ-Bandits", "ShortName": "Bandits", "Email": "", "Status": "0" }, { "TeamId": 369, "TeamName": "ZZZZ-Mercenaries", "ShortName": "Mercenaries", "Email": "", "Status": "0" }, { "TeamId": 370, "TeamName": "ZZZZ-11 Tigers", "ShortName": "11 Tigers", "Email": "", "Status": "0" }, { "TeamId": 371, "TeamName": "ZZZZ-Titans", "ShortName": "Titans", "Email": "", "Status": "0" }, { "TeamId": 372, "TeamName": "Sharks CC", "ShortName": "Sharks CC", "Email": "", "Status": "1" }, { "TeamId": 373, "TeamName": "ZZZZ-New Cricket League", "ShortName": "New Cricket League", "Email": "tbd", "Status": "0" }, { "TeamId": 374, "TeamName": "ZZZZ-TrailBlazers_XXX", "ShortName": "", "Email": "", "Status": "0" }, { "TeamId": 375, "TeamName": "ZZZZ-TrailBlazers", "ShortName": "", "Email": "", "Status": "0" }, { "TeamId": 376, "TeamName": "Mighty Chargers", "ShortName": "Mighty Chargers", "Email": "satish.andhoor@gmail.com", "Status": "1" }, { "TeamId": 377, "TeamName": "Baazigar of Bay", "ShortName": "BOB", "Email": "pratipkumardas@gmail.com", "Status": "1" }, { "TeamId": 378, "TeamName": "Phidel Brothers", "ShortName": "Phidel Brothers", "Email": "kashyap.ananth@gmail.com", "Status": "1" }, { "TeamId": 379, "TeamName": "Rising stars", "ShortName": "Rising stars", "Email": "", "Status": "1" }, { "TeamId": 381, "TeamName": "Advik", "ShortName": "Advik", "Email": "", "Status": "1" }, { "TeamId": 389, "TeamName": "SPARTANS", "ShortName": "", "Email": "", "Status": "1" }, { "TeamId": 390, "TeamName": "Dravidians", "ShortName": "", "Email": "", "Status": "1" }, { "TeamId": 391, "TeamName": "2PointO", "ShortName": "2PointO", "Email": "", "Status": "1" }, { "TeamId": 392, "TeamName": "SJPH", "ShortName": "SJPH", "Email": "", "Status": "1" }, { "TeamId": 393, "TeamName": "TakeItEasy CC", "ShortName": "TakeItEasy CC", "Email": "", "Status": "1" }, { "TeamId": 394, "TeamName": "ZZZZ_Ludicrous", "ShortName": "Ludicrous", "Email": "", "Status": "1" }, { "TeamId": 395, "TeamName": "ZZZ_Afghan", "ShortName": "", "Email": "", "Status": "0" }, { "TeamId": 396, "TeamName": "Kingsmen", "ShortName": "Kingsmen", "Email": "", "Status": "1" }, { "TeamId": 397, "TeamName": "Knights Watch XI", "ShortName": "", "Email": "", "Status": "1" }, { "TeamId": 398, "TeamName": "Slammers", "ShortName": "Slammers", "Email": "vishal.dogra@gmail.com", "Status": "1" }, { "TeamId": 400, "TeamName": "Bay Risers", "ShortName": "", "Email": "", "Status": "1" }, { "TeamId": 401, "TeamName": "Fireballs", "ShortName": "FB", "Email": "", "Status": "1" }, { "TeamId": 402, "TeamName": "Ravens", "ShortName": "", "Email": "", "Status": "1" }, { "TeamId": 403, "TeamName": "Vulcans", "ShortName": "Vulcans", "Email": "", "Status": "1" }, { "TeamId": 404, "TeamName": "Ssshhh", "ShortName": "", "Email": "", "Status": "1" }, { "TeamId": 405, "TeamName": "Utpatang", "ShortName": "Utpatang", "Email": "", "Status": "1" }, { "TeamId": 418, "TeamName": "Shining Stars", "ShortName": "Shining Stars", "Email": "", "Status": "1" }, { "TeamId": 419, "TeamName": "Khiladi", "ShortName": "", "Email": "", "Status": "1" }, { "TeamId": 420, "TeamName": "Bullets", "ShortName": "Bullets", "Email": "", "Status": "1" }, { "TeamId": 421, "TeamName": "Delta Force", "ShortName": "Delta Force", "Email": "", "Status": "1" }, { "TeamId": 422, "TeamName": "Supernovas", "ShortName": "Supernovas", "Email": "", "Status": "1" }, { "TeamId": 425, "TeamName": "Vikrant", "ShortName": "Vikrant", "Email": "", "Status": "1" }, { "TeamId": 426, "TeamName": "CCC XI", "ShortName": "CCC XI", "Email": "", "Status": "1" }, { "TeamId": 427, "TeamName": "Gully Boyz", "ShortName": "Gully Boyz", "Email": "", "Status": "1" }, { "TeamId": 428, "TeamName": "Nighthawks", "ShortName": "Nighthawks", "Email": "", "Status": "1" }, { "TeamId": 429, "TeamName": "Sher X1", "ShortName": "Sher X1", "Email": "", "Status": "1" }, { "TeamId": 430, "TeamName": "Garfielders", "ShortName": "Garfielders", "Email": "", "Status": "1" }, { "TeamId": 431, "TeamName": "Phoenix Risers", "ShortName": "Phoenix Risers", "Email": "", "Status": "1" }, { "TeamId": 432, "TeamName": "Jewel of India", "ShortName": "Jewel of India", "Email": "", "Status": "1" }, { "TeamId": 433, "TeamName": "COBRAS", "ShortName": "COBRAS", "Email": "", "Status": "1" }, { "TeamId": 434, "TeamName": "Skippers", "ShortName": "Skippers", "Email": "", "Status": "1" }, { "TeamId": 435, "TeamName": "Royal Kings", "ShortName": "Royal Kings", "Email": "", "Status": "1" }, { "TeamId": 436, "TeamName": "Dominators", "ShortName": "Dominators", "Email": "", "Status": "1" }, { "TeamId": 437, "TeamName": "Breaking Bats", "ShortName": "Breaking Bats", "Email": "", "Status": "1" }, { "TeamId": 438, "TeamName": "SJ Spartans", "ShortName": "SJ Spartans", "Email": "", "Status": "1" }, { "TeamId": 439, "TeamName": "Jersey XI", "ShortName": "Jersey XI", "Email": "", "Status": "1" }, { "TeamId": 440, "TeamName": "Fairfield Falcons", "ShortName": "Fairfield Falcons ", "Email": "", "Status": "1" }, { "TeamId": 441, "TeamName": "Gladiators", "ShortName": "Gladiators", "Email": "", "Status": "1" }, { "TeamId": 442, "TeamName": "Game Strikers", "ShortName": "Game Strikers", "Email": "", "Status": "1" }, { "TeamId": 443, "TeamName": "Dark Knights", "ShortName": "Dark Knights", "Email": "", "Status": "1" }, { "TeamId": 444, "TeamName": "Cricket Maniacs", "ShortName": "Cricket Maniacs", "Email": "", "Status": "1" }, { "TeamId": 445, "TeamName": "CaliVaasis", "ShortName": "CaliVaasis", "Email": "", "Status": "1" }, { "TeamId": 446, "TeamName": "Trophy Fighters", "ShortName": "", "Email": "", "Status": "1" }, { "TeamId": 447, "TeamName": "Ludicrous", "ShortName": "Ludicrous", "Email": "", "Status": "1" }, { "TeamId": 448, "TeamName": "Phantoms", "ShortName": "Phantoms", "Email": "", "Status": "1" }, { "TeamId": 449, "TeamName": "Vikings", "ShortName": "Vikings", "Email": "", "Status": "1" }, { "TeamId": 450, "TeamName": "Raptors", "ShortName": "Raptors", "Email": "", "Status": "1" }, { "TeamId": 451, "TeamName": "Divit", "ShortName": "Divit", "Email": "", "Status": "1" }, { "TeamId": 452, "TeamName": "Now Warriors", "ShortName": "Now Warriors", "Email": "", "Status": "1" }, { "TeamId": 453, "TeamName": "Almaden CC", "ShortName": "Almaden CC", "Email": "", "Status": "1" }, { "TeamId": 454, "TeamName": "Falcons ", "ShortName": "Falcons ", "Email": "", "Status": "1" }, { "TeamId": 455, "TeamName": "FC SPARTANS", "ShortName": "FC SPARTANS", "Email": "", "Status": "1" }, { "TeamId": 456, "TeamName": " Hitmen XI", "ShortName": " Hitmen XI", "Email": "", "Status": "1" }, { "TeamId": 457, "TeamName": "Stanford CC", "ShortName": "Stanford CC", "Email": "", "Status": "1" }, { "TeamId": 458, "TeamName": " Legendary Lions", "ShortName": " Legendary Lions", "Email": "", "Status": "1" }, { "TeamId": 459, "TeamName": "KoolAgents", "ShortName": "KoolAgents", "Email": "", "Status": "1" }, { "TeamId": 460, "TeamName": "Scorpions", "ShortName": "Scorpions ", "Email": "", "Status": "1" }, { "TeamId": 461, "TeamName": "Roadies", "ShortName": "", "Email": "", "Status": "1" }, { "TeamId": 463, "TeamName": "Bhola Champions", "ShortName": "", "Email": "", "Status": "1" }, { "TeamId": 464, "TeamName": "Mavericks", "ShortName": "Mavericks", "Email": "", "Status": "1" }, { "TeamId": 466, "TeamName": "Dolphins", "ShortName": "", "Email": "", "Status": "1" }];
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  async getTeamDetails(teamId) {
    try {
      //const response = await fetch(`${API_BASE_URL}/team/${teamId}`);
      //let data = await response.json();
      let data = { "TeamId": teamId, "TeamName": "Testing", "ShortName": "Testing", "Email": "", "Status": "1" };
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  async getTournaments() {
    try {
      //const response = await fetch(`${API_BASE_URL}/tournaments`);
      //let data = await response.json();
      let data = [{"Id":15,"Name":"2014 League Tournament","Shortname":"2014 League","StartDate":"2014-03-01T08:00:00.000Z","EndDate":"2014-06-01T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":16,"Name":"2017 B.A.T.S","Shortname":"2017 B.A.T.S","StartDate":"2017-04-23T07:00:00.000Z","EndDate":"2017-06-17T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":33,"Name":"2014 Knock Out Tournament","Shortname":"2014 KO","StartDate":"2014-06-01T07:00:00.000Z","EndDate":"2014-06-15T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":34,"Name":"2014 Open Tournament","Shortname":"2014 Open Tournament","StartDate":"2014-06-14T07:00:00.000Z","EndDate":"2014-10-04T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":40,"Name":"2014 CANVAS InfoTech  Floodlight Tournament","Shortname":"2014 FLT Tournament","StartDate":"2014-10-04T07:00:00.000Z","EndDate":"2014-11-08T08:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":43,"Name":"2014 Winter League Tournament","Shortname":"2014 WL Tournament","StartDate":"2014-11-01T07:00:00.000Z","EndDate":"2015-02-21T08:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":44,"Name":"2015 League Tournament","Shortname":"2015 League Tournament","StartDate":"2015-02-22T08:00:00.000Z","EndDate":"2015-05-16T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":45,"Name":"2015 Dr Prakash Advani TCA Open Tournament","Shortname":"2015 Dr Prakash Advani TCA Open Tournament","StartDate":"2015-05-17T07:00:00.000Z","EndDate":"2015-09-26T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":46,"Name":"2015 Chugh LLP TCA Floodlight Tournament","Shortname":"2015 Chugh LLP TCA Floodlight Tournament","StartDate":"2015-10-03T07:00:00.000Z","EndDate":"2015-11-01T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":47,"Name":"2015 The Gongzuo TCA Winter League Tournament","Shortname":"2015 The Gongzuo Winter League Tournament","StartDate":"2015-10-31T07:00:00.000Z","EndDate":"2016-02-14T08:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":48,"Name":"2016 League Tournament ","Shortname":"2016 League Tournament","StartDate":"2016-02-20T08:00:00.000Z","EndDate":"2016-05-14T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":49,"Name":"2016 Dr Prakash Advani TCA Open Tournament","Shortname":"2016 Open Tournament","StartDate":"2016-05-15T07:00:00.000Z","EndDate":"2016-09-18T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":50,"Name":"2016 Realtor-Manu Changotra TCA FLT","Shortname":"2016 FLT Plus","StartDate":"2016-09-18T07:00:00.000Z","EndDate":"2016-11-05T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":51,"Name":"2016 The Gongzuo TCA Winter League ","Shortname":"2016 TCA Winter League","StartDate":"2016-11-05T07:00:00.000Z","EndDate":"2017-02-19T08:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":53,"Name":"2017 League Tournament","Shortname":"2017 League Tournament","StartDate":"2017-02-19T08:00:00.000Z","EndDate":"2017-05-14T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":54,"Name":"2017 Dr Prakash Advani TCA Open Tournament","Shortname":"2017 Open Tournament","StartDate":"2017-05-14T07:00:00.000Z","EndDate":"2017-09-16T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":55,"Name":"2017 UBERTAL TCA FLT","Shortname":"2017 FLT","StartDate":"2017-09-17T07:00:00.000Z","EndDate":"2017-10-30T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":56,"Name":"2017 The Gongzuo TCA Winter League ","Shortname":"2017 Winter League ","StartDate":"2017-11-04T07:00:00.000Z","EndDate":"2018-02-10T08:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":57,"Name":"2018 TCA League Tournament","Shortname":"2018 TCA League","StartDate":"2018-02-11T08:00:00.000Z","EndDate":"2018-05-12T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":58,"Name":"2018 GypsOid TCA Open Tournament","Shortname":"2018 GypsOid TCA Open Tournament","StartDate":"2018-05-13T07:00:00.000Z","EndDate":"2018-09-15T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":59,"Name":"2018 TCA FLT","Shortname":"2018 FLT","StartDate":"2018-09-16T07:00:00.000Z","EndDate":"2018-10-28T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":60,"Name":"2018 Nextgen Technologies  TCA Winter League","Shortname":"2018 TCA Winter League","StartDate":"2018-11-03T07:00:00.000Z","EndDate":"2019-02-10T08:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":61,"Name":"2019 Workato.com TCA League ","Shortname":"2019 Workato.com TCA League","StartDate":"2019-02-23T08:00:00.000Z","EndDate":"2019-05-18T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":62,"Name":"2019 CricFantasy TCA Open ","Shortname":"2019 TCA Open ","StartDate":"2019-06-01T07:00:00.000Z","EndDate":"2019-09-21T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":63,"Name":"2019 You Smile Dental TCA FLT","Shortname":"2019 TCA FLT","StartDate":"2019-09-22T07:00:00.000Z","EndDate":"2019-11-03T07:00:00.000Z","Win":16,"Loss":0,"Tie":8,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":64,"Name":"2019 You Smile Dental TCA Winter League","Shortname":"2019 You Smile Dental TCA Winter League","StartDate":"2019-11-09T08:00:00.000Z","EndDate":"2020-02-15T08:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":65,"Name":"2020 Workato.com TCA League ","Shortname":"2020 Workato.com TCA League ","StartDate":"2020-02-18T08:00:00.000Z","EndDate":"2020-05-16T07:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":67,"Name":"2021 TCA Comeback Championship","Shortname":"2021 Comeback Championship","StartDate":"2021-06-01T07:00:00.000Z","EndDate":"2021-07-31T07:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":69,"Name":"2021 Comeback Tourney","Shortname":"Comeback Tourney","StartDate":"2021-06-05T07:00:00.000Z","EndDate":"2021-07-31T07:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":70,"Name":"2021 TCA Open ","Shortname":"2021 TCA Open ","StartDate":"2021-08-02T07:00:00.000Z","EndDate":"2021-11-06T07:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":71,"Name":"2021 TCA Winter League","Shortname":"2021 TCA Winter League","StartDate":"2021-11-13T08:00:00.000Z","EndDate":"2022-02-19T08:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":72,"Name":"2022 TCA League Tournament","Shortname":"2022 TCA League","StartDate":"2022-02-26T08:00:00.000Z","EndDate":"2022-05-22T07:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":73,"Name":"2022 TCA Open ","Shortname":"2022 TCA Open","StartDate":"2022-06-04T07:00:00.000Z","EndDate":"2022-09-17T07:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":74,"Name":"2022 TCA FLT","Shortname":"2022 TCA FLT","StartDate":"2022-09-18T07:00:00.000Z","EndDate":"2022-11-13T08:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":75,"Name":"2022 TCA Winter League","Shortname":"2022 Winter","StartDate":"2022-11-13T08:00:00.000Z","EndDate":"2023-02-27T08:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":76,"Name":"2023 TCA League ","Shortname":"2023 TCA League","StartDate":"2023-03-06T08:00:00.000Z","EndDate":"2023-05-21T07:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":77,"Name":"2023 TCA Open","Shortname":"2023 Open","StartDate":"2023-05-29T07:00:00.000Z","EndDate":"2023-09-09T07:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":78,"Name":"2023 TCA FLT","Shortname":"2023 FLT","StartDate":"2023-09-09T07:00:00.000Z","EndDate":"2023-10-29T07:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2},{"Id":79,"Name":"2023 Fidelity Investments TCA Winter League","Shortname":"2023 Fidelity Investments TCA WL","StartDate":"2023-10-30T07:00:00.000Z","EndDate":"2024-02-25T08:00:00.000Z","Win":16,"Loss":0,"Tie":10,"Abandoned":8,"LossWalkOver":-2,"Bonus":2}];
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  async getTournamentDetails(tournamentId) {
    try {
      //const response = await fetch(`${API_BASE_URL}/tournaments/${tournamentId}`);
      //let data = await response.json();
      let data = { "Id": 78, "Name": "2023 TCA FLT", "Shortname": "2023 FLT", "StartDate": "2023-09-09T07:00:00.000Z", "EndDate": "2023-10-22T07:00:00.000Z", "Win": 16, "Loss": 0, "Tie": 10, "Abandoned": 8, "LossWalkOver": -2, "Bonus": 2 };
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  async getPendingScoreCards() {
    try {
      const response = await fetch(`${LEGACY_DOMAIN}/pendingscorecard`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  async getBriefSchedule(tourId) {
    try {
      let url = `${LEGACY_DOMAIN}/briefSchedule`;
      if (tourId) {
        url = url + `?TourId=${tourId}`
      } else {
        url = url + `?TourId=All`
      }
      const response = await fetch(url);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }

  }
  async getPointsTable() {
    try {
      const response = await fetch(`${LEGACY_DOMAIN}/pointtable`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  /**
   * For Tournament Details Page - Get Points Table
   * @param {*} tournamentId 
   * @returns 
   */
  async getFullPointsTable(tournamentId) {
    //https://tennisballcricket.com/fullPointTable?TourId=77
    try {
      const response = await fetch(`${LEGACY_DOMAIN}/fullPointTable?TourId=${tournamentId}`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }

  }
  /**
   * For Tournament Details Page - Get Scores
   * @param {*} tournamentId 
   * @returns 
   */
  async getScores(tournamentId) {
    //https://tennisballcricket.com/scores?TourId=77
    try {
      let url = `${LEGACY_DOMAIN}/scores?TourId=${tournamentId}`
      const response = await fetch(url);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }


  /*** 
   * Matches Related API Calls
   */

  async getDetailedScoreCard(matchId) {
    //https://tennisballcricket.com/matchdetailscore?MatchId=6866
    try {
      const response = await fetch(`${LEGACY_DOMAIN}/matchdetailscore?MatchId=${matchId}`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  async getDetailedScoreCardSummary(matchId) {

    //ttps://tennisballcricket.com/matchd/6866
    try {
      const response = await fetch(`${LEGACY_DOMAIN}/matchd/${matchId}`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  /** Head 2 Head */
  async getHead2Head(teamId1, teamId2) {
    //https://tennisballcricket.com/hthData?Team1=20&Team2=448
    try {
      const response = await fetch(`${LEGACY_DOMAIN}/hthData?Team1=${teamId1}&Team2=${teamId2}`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  /**
   * Get Live Match Data
   */
  async getLiveMatchData(matchId) {
    try {
      let url = `${LEGACY_DOMAIN}/getLiveMatchData`;
      if (matchId) {
        url = url + `?id=${matchId}`;
      }
      const response = await fetch(url);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  /** Get FAQ information */
  async getFAQData() {
    try {
      const response = await fetch(`${API_BASE_URL}/faq`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
  /** Get Grounds */
  async getGrounds() {

    try {
      const response = await fetch(`${LEGACY_DOMAIN}/displaydata1?tablename=playgrounds`);
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('An error occurred while fetching data.');
    }
  }
}
export default new ApiService();
